import { IObject } from '../types';
import { isEmail, isEmpty, maxLength } from './Validator';

export enum ValidationMessage {
  Empty = 'Required',
  LengthExceeded = 'Email must be less than 200 characters long',
  Invalid = 'Please enter a valid email address',
}

const emailValidation = (email: string, fieldName: string | number): IObject => {
  const errors: IObject = {};

  if (isEmpty(email)) {
    errors[fieldName] = ValidationMessage.Empty;
  } else if (!maxLength(email, 200)) {
    errors[fieldName] = ValidationMessage.LengthExceeded;
  } else if (!isEmail(email)) {
    errors[fieldName] = ValidationMessage.Invalid;
  }

  return { ...errors };
};

export default emailValidation;
